import React from 'react'
import PropTypes from 'prop-types'
import FormSelect from 'components/forms/bases/FormSelect'

const FormTextAlign = ({
  ...props,
}) => {
  return (
    <FormSelect
      label="Alignment"
      options={
        ['left', 'center', 'right']
      }
      {...props}
    />
  )
}

FormTextAlign.propTypes = {}
FormTextAlign.defaultProps = {}

export default FormTextAlign



// WEBPACK FOOTER //
// ./src/components/forms/FormTextAlign.js